// extracted by mini-css-extract-plugin
export default {"scrollButton":"Chat-styles__scrollButton___plLjS","scrollButtonArrow":"Chat-styles__scrollButtonArrow___E49a1"};